var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomsUpSquareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#5CB335",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4999 27.3888C34.2149 27.3888 33.9299 27.2838 33.7049 27.0588L29.9999 23.3538L26.2949 27.0588C25.8599 27.4938 25.1399 27.4938 24.7049 27.0588C24.2699 26.6238 24.2699 25.9038 24.7049 25.4688L29.2049 20.9688C29.6399 20.5338 30.3599 20.5338 30.7949 20.9688L35.2949 25.4688C35.7299 25.9038 35.7299 26.6238 35.2949 27.0588C35.0699 27.2838 34.7849 27.3888 34.4999 27.3888Z",
    fill: "#5AAD46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.8887C29.385 34.8887 28.875 34.3787 28.875 33.7637V21.7637C28.875 21.1487 29.385 20.6387 30 20.6387C30.615 20.6387 31.125 21.1487 31.125 21.7637V33.7637C31.125 34.3937 30.615 34.8887 30 34.8887Z",
    fill: "#5AAD46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 39.3443C26.8349 39.3443 23.6549 38.8343 20.6399 37.8293C20.0549 37.6343 19.7399 36.9893 19.9349 36.4043C20.1299 35.8193 20.7749 35.4893 21.3599 35.6993C26.9399 37.5593 33.0749 37.5593 38.6549 35.6993C39.2399 35.5043 39.8849 35.8193 40.0799 36.4043C40.2749 36.9893 39.9599 37.6343 39.3749 37.8293C36.3449 38.8493 33.1649 39.3443 29.9999 39.3443Z",
    fill: "#5AAD46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6443,
    y: 15.1475,
    width: 29.7085,
    height: 29.7197,
    rx: 4,
    stroke: "#5AAD46",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomsUpSquareIcon);
export default __webpack_public_path__ + "static/media/bottoms-up-square-icon.582a11ff11526001bb3d1c194bbe913e.svg";
export { ForwardRef as ReactComponent };